import React, { Component } from 'react'
import configs from '../../../configs.json'

class CTA extends Component {
    render() {
        return (
            <div className="parallax-container">
                <div className="parallax">
                    <img id="parallax-img" alt='medcine' src={require('../../../static/imgs/cta-bg.jpg')}/>
                </div>
                <div className="section no-pad-bot" style={{paddingTop: '20px'}}>
                    <h1 className="header center text-lighten-2" style={{color:configs.colors.primary, textShadow: '3px 3px black'}} >{configs.cta.title}</h1>
                    <div className="row center">
                        <h4 className="header col s12 light white-text" style={{textShadow: '2px 2px black'}}>{configs.cta.description}</h4>
                    </div>
                    <br/>
                    <div className="row center">
                        <div className='col s12 center-align'>
                            <a href={configs.cta.link} id="hero-btn" className="btn-large waves-effect waves-light" style={{backgroundColor: configs.colors.secondary}}>{configs.cta.btn}</a>
                        </div>
                    </div>
                    <br/><br/>
                </div>
            </div>
        )
    }
}

export default CTA